/* src/app/app.component.scss */
:host {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-width: 0;
}
:host .theme-options-button {
  position: absolute;
  top: 160px;
  right: 0;
  width: 48px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
  border-radius: 0;
  margin: 0;
  pointer-events: auto;
  opacity: 0.9;
  z-index: 998;
}
:host .theme-options-button mat-icon {
  animation: rotating 3s linear infinite;
}
:host .theme-options-button:hover {
  opacity: 1;
}
:host .theme-options-sidebar {
  width: 360px;
  min-width: 360px;
  max-width: 360px;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL2FwcC9hcHAuY29tcG9uZW50LnNjc3MiXSwKICAic291cmNlc0NvbnRlbnQiOiBbIkB1c2UgJ0BmdXNlL3Njc3MvcGFydGlhbHMvYnJlYWtwb2ludHMuc2NzcycgYXMgKjtcblxuOmhvc3Qge1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXg6IDEgMSBhdXRvO1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGhlaWdodDogMTAwJTtcbiAgICBtaW4td2lkdGg6IDA7XG5cbiAgICAudGhlbWUtb3B0aW9ucy1idXR0b24ge1xuICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgIHRvcDogMTYwcHg7XG4gICAgICAgIHJpZ2h0OiAwO1xuICAgICAgICB3aWR0aDogNDhweDtcbiAgICAgICAgaGVpZ2h0OiA0OHB4O1xuICAgICAgICBsaW5lLWhlaWdodDogNDhweDtcbiAgICAgICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgICAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgICAgIGJvcmRlci1yYWRpdXM6IDA7XG4gICAgICAgIG1hcmdpbjogMDtcbiAgICAgICAgcG9pbnRlci1ldmVudHM6IGF1dG87XG4gICAgICAgIG9wYWNpdHk6IDAuOTtcbiAgICAgICAgei1pbmRleDogOTk4O1xuXG4gICAgICAgIG1hdC1pY29uIHtcbiAgICAgICAgICAgIGFuaW1hdGlvbjogcm90YXRpbmcgM3MgbGluZWFyIGluZmluaXRlO1xuICAgICAgICB9XG5cbiAgICAgICAgJjpob3ZlciB7XG4gICAgICAgICAgICBvcGFjaXR5OiAxO1xuICAgICAgICB9XG4gICAgfVxuXG4gICAgLnRoZW1lLW9wdGlvbnMtc2lkZWJhciB7XG4gICAgICAgIHdpZHRoOiAzNjBweDtcbiAgICAgICAgbWluLXdpZHRoOiAzNjBweDtcbiAgICAgICAgbWF4LXdpZHRoOiAzNjBweDtcbiAgICB9XG59XG4iXSwKICAibWFwcGluZ3MiOiAiO0FBRUE7QUFDSSxZQUFBO0FBQ0EsV0FBQTtBQUNBLFFBQUEsRUFBQSxFQUFBO0FBQ0EsU0FBQTtBQUNBLFVBQUE7QUFDQSxhQUFBOztBQUVBLE1BQUEsQ0FBQTtBQUNJLFlBQUE7QUFDQSxPQUFBO0FBQ0EsU0FBQTtBQUNBLFNBQUE7QUFDQSxVQUFBO0FBQ0EsZUFBQTtBQUNBLGNBQUE7QUFDQSxVQUFBO0FBQ0EsaUJBQUE7QUFDQSxVQUFBO0FBQ0Esa0JBQUE7QUFDQSxXQUFBO0FBQ0EsV0FBQTs7QUFFQSxNQUFBLENBZkoscUJBZUk7QUFDSSxhQUFBLFNBQUEsR0FBQSxPQUFBOztBQUdKLE1BQUEsQ0FuQkosb0JBbUJJO0FBQ0ksV0FBQTs7QUFJUixNQUFBLENBQUE7QUFDSSxTQUFBO0FBQ0EsYUFBQTtBQUNBLGFBQUE7OyIsCiAgIm5hbWVzIjogW10KfQo= */
